import { Box } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IButtonsBackground {
  buttonsBackgroundColor?: string;
  removeCircleBG?: boolean;
}

export const ButtonsBackground = ({
  buttonsBackgroundColor,
  removeCircleBG,
}: IButtonsBackground) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: isDesktop ? '56px' : '100%',
          bgcolor: buttonsBackgroundColor || 'primary.shade_100',
          bottom: '0',
          right: '0',
          borderBottomLeftRadius: '16px',
          borderBottomRightRadius: '16px',
        }}
      />
      {removeCircleBG ? null : (
        <>
          <Box
            sx={{
              position: 'absolute',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              bottom: '-75px',
              right: '-50px',
              bgcolor: '#ffffff4d',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              top: '-70px',
              left: '-45px',
              bgcolor: '#ffffff4d',
            }}
          />
        </>
      )}
    </>
  );
};
